import React, { useRef } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';

const QRCodeGenerator = ({ value }) => {
  const qrRef = useRef();

  const handleDownload = () => {
    html2canvas(qrRef.current).then(canvas => {
      const link = document.createElement('a');
      link.download = 'trustgrid-qr.png';
      link.href = canvas.toDataURL();
      link.click();
    });
  };

  return (
    <div className="text-center mt-6">
      <div ref={qrRef} style={{ display: 'inline-block' }}>
        <QRCodeCanvas value={value} size={256} />
      </div>
      <br />
      <button onClick={handleDownload} className="mt-3 bg-blue-600 text-white px-4 py-2 rounded">
        Download QR Code
      </button>
    </div>
  );
};

export default QRCodeGenerator;
